export function getIcon(
  type:
    | "delete"
    | "pin"
    | "unpin"
    | "forward"
    | "reply"
    | "replyPrivately"
    | "menu"
    | "forwarded"
    | "pinned"
    | "seenInfo"
    | "edit"
    | "copy",
  color: string = "#212529",
  size: string = "20px",
): string {
  const icons: Record<string, string> = {
    delete: `
      <svg xmlns="http://www.w3.org/2000/svg"
           width="${size}"
           height="${size}"
           viewBox="0 0 20 20">
        <path fill="${color}"
              stroke="${color}"
              stroke-width="1"
              d="M8.5 4h3a1.5 1.5 0 0 0-3 0m-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.054l-1.194 10.344A3 3 0 0 1 12.272 18H7.728a3 3 0 0 1-2.98-2.656L3.554 5H2.5a.5.5 0 0 1 0-1zM5.741 15.23A2 2 0 0 0 7.728 17h4.544a2 2 0 0 0 1.987-1.77L15.439 5H4.561zM8.5 7.5A.5.5 0 0 1 9 8v6a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5M12 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
      </svg>
    `,

    pin: `
      <svg xmlns="http://www.w3.org/2000/svg"
           width="${size}"
           height="${size}"
           viewBox="0 0 24 24">
        <path fill="${color}"
              stroke="${color}"
              stroke-width="1"
              d="M14 12.41V5h1V4H8v1h1v7.41l-2 2V15h9v-.59zM17 14v2h-5v4.5l-.5 1.5l-.5-1.5V16H6v-2l2-2V6H7V3h9v3h-1v6z"/>
      </svg>
    `,

    unpin: `
      <svg xmlns="http://www.w3.org/2000/svg"
           width="${size}"
           height="${size}"
           viewBox="0 0 24 24">
        <path fill="${color}"
              stroke="${color}"
              stroke-width="1"
              d="m20.97 17.172l-1.414 1.414l-3.535-3.535l-.073.074l-.707 3.536l-1.415 1.414l-4.242-4.243l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.243-4.243L5.34 8.761l3.536-.707l.073-.074l-3.536-3.536L6.828 3.03zM10.365 9.394l-.502.502l-2.822.565l6.5 6.5l.564-2.822l.502-.502zm8.411.074l-1.34 1.34l1.414 1.415l1.34-1.34l.707.707l1.415-1.415l-8.486-8.485l-1.414 1.414l.707.707l-1.34 1.34l1.414 1.415l1.34-1.34z"/>
      </svg>
    `,
    forward: `
   <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24"><path fill="${color}" d="m15.692 16.308l-.713-.708l4.6-4.6l-4.6-4.6l.713-.708L21 11zM3 18v-3q0-1.864 1.318-3.182T7.5 10.5h7.464l-4.1-4.1l.713-.708L16.884 11l-5.307 5.308l-.713-.708l4.1-4.1H7.5q-1.442 0-2.471 1.029T4 15v3z" stroke-width="1" stroke="${color}"/></svg>
    `,
    reply: `
   <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24"><path fill="${color}" d="M8.308 16.308L3 11l5.308-5.308l.713.708l-4.6 4.6l4.6 4.6zM20 18v-3q0-1.442-1.029-2.471T16.5 11.5H9.037l4.1 4.1l-.714.708L7.116 11l5.307-5.308l.714.708l-4.1 4.1H16.5q1.864 0 3.182 1.318T21 15v3z" stroke-width="1" stroke="${color}"/></svg>
    `,
    replyPrivately: `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24">
        <path fill="${color}" d="M6.59 13.59L2 9l4.59-4.59L8 5.82 4.83 9H13c1.86 0 3.4 1.28 3.86 3H15.3c-.4-1.16-1.5-2-2.8-2H4.83L8 12.18z"/>
        <path fill="${color}" d="M18 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1.5c-2 0-5 1-5 2.5V19h10v-1.5c0-1.5-3-2.5-5-2.5z"/>
      </svg>
    `,
    menu: `
  
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20"><path fill="${color}" d="M10.001 7.8a2.2 2.2 0 1 0 0 4.402A2.2 2.2 0 0 0 10 7.8zm0-2.6A2.2 2.2 0 1 0 9.999.8a2.2 2.2 0 0 0 .002 4.4m0 9.6a2.2 2.2 0 1 0 0 4.402a2.2 2.2 0 0 0 0-4.402" stroke-width="0.5" stroke="${color}"/></svg>

    `,
    forwarded: `
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <polyline points="17 1 21 5 17 9"></polyline>
                                <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                                <polyline points="7 23 3 19 7 15"></polyline>
                                <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                              </svg>
    `,
    pinned: `
     <svg xmlns="http://www.w3.org/2000/svg" width="20px"
                                    height="20px" viewBox="0 0 24 24">
                                    <path fill="#dc3545"
                                      d="M16.729 4.271a1 1 0 0 0-1.414-.004a1 1 0 0 0-.225.355c-.832 1.736-1.748 2.715-2.904 3.293C10.889 8.555 9.4 9 7 9a1.01 1.01 0 0 0-.923.617a1 1 0 0 0 .217 1.09l3.243 3.243L5 20l6.05-4.537l3.242 3.242a1 1 0 0 0 .326.217q.185.077.382.078c.197.001.26-.027.382-.078A1 1 0 0 0 16 18c0-2.4.444-3.889 1.083-5.166c.577-1.156 1.556-2.072 3.293-2.904a1 1 0 0 0 .354-.225a1 1 0 0 0-.004-1.414z" />
                                  </svg>
    `,
    exit: `
     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
    `,
    clearChat: `
     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 24 24">
              <g fill="none">
                <path d="M2.5 3h19v14h-15l-4 3.5z" />
                <path stroke="#dc3545" stroke-linecap="square" stroke-width="1.4"
                  d="M2.5 3h19v14h-15l-4 3.5zm12.329 4.172L12 10m0 0l-2.828 2.828M12 10l2.829 2.828M12 10L9.172 7.172" />
              </g>
            </svg>`,
    seenInfo: `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24">
        <path fill="${color}" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" stroke="${color}" stroke-width="1"/>
      </svg>`,
    edit: `
     <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path fill="${color}" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM21.41 6.34l-3.75-3.75l-2.53 2.54l3.75 3.75z" stroke-width="0.5" stroke="${color}"/></svg>`,
    copy: `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24">
        <path fill="${color}" d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z"/>
      </svg>`
  };

  return icons[type];
}
